import {
    Table,
    TableContainer,
    Tbody,
    Td,
    Th,
    Thead,
    Tr,
} from '@chakra-ui/react';
// Custom components
import React, { useEffect, useState } from 'react';
import { IoSearchOutline } from 'react-icons/io5';
import { useDispatch, useSelector } from 'react-redux';
import { dueAmountReports, dueExcelReports, viewReports } from '../../../redux/actions/Report.action';
import { FiTarget } from 'react-icons/fi';
import { Button, Modal } from 'react-bootstrap';
import moment from 'moment';
import ReactPaginate from 'react-paginate';
import * as XLSX from 'xlsx';
import { BsDownload } from 'react-icons/bs';

export default function ServiceReport() {

    const dispatch = useDispatch();
    const reportData = useSelector((state) => state.report)
    const [reportModal, setReportModal] = useState(false);
    const reportToggle = () => { setReportModal(!reportModal); };
    const [isExporting, setIsExporting] = useState(false);
    const [formData, setFormData] = useState({
        date: '',
        startDate: '',
        endDate: '',
        type: '',
        search: ''
    })

    const [mainPage, setMainPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const limits = {
        page: mainPage,
        limit: rowsPerPage,
    };

    const handleReport = (billNo) => {
        const payload = {
            billNumber: billNo
        }
        dispatch(viewReports(payload))
    }

    const ChangeMainPage = ({ selected }) => {
        setMainPage(selected + 1);
    };
    const totalRecords = reportData?.dueAmountReport?.data?.totalRecord || 0;
    const PageCount = Math.ceil(totalRecords / rowsPerPage);

    const handleFormData = (e) => {
        const { name, value } = e.target;
        setFormData((prev => ({
            ...prev,
            [name]: value,
            ...(name === 'startDate' || name === 'endDate' ? { date: '' } : {}),
            ...(name === 'date' ? { startDate: '', endDate: '' } : {})
        })))
    }

    useEffect(() => {
        let payload = {}
        if (formData.date) {
            payload.date = formData.date;
        }

        if (formData.startDate || formData.endDate) {
            payload.startDate = formData.startDate;
            payload.endDate = formData.endDate;
        }

        if (formData.type) {
            payload.type = formData.type;
        }

        if (formData) {
            dispatch(dueAmountReports(formData.search, limits, payload))
        }
    }, [formData, mainPage, rowsPerPage])

    const handleExport = () => {
        const data = {
            date: formData.date,
            startDate: formData.startDate,
            endDate: formData.endDate,
            type: formData.type,            
        };
        dispatch(dueExcelReports(formData.search, data));
        setIsExporting(true);
    };

    useEffect(() => {
        if (
            isExporting &&
            reportData?.getDueExcelData?.data?.finalResult?.length
        ) {
            const exportData = reportData?.getDueExcelData?.data?.finalResult.map((item) => ({
                "Date": item.date ? moment(item.date).format('DD/MM/YYYY') : '',
                "Bill No": item.billNo,
                "Name": item.name,
                "Phone Number": item.phoneNumber,
                "Service Name": item.packageName || item.serviceName || '-',
                "Rate": item.serviceRate || '-',
                "Bill Type": item.billType,
                "Total Amount": item.totalAmount,
                "Paid Amount": item.paidAmount,
                "Due Amount": item.dueAmount,
                "Branch": item.branch,
                "User": item.billGenerateBy
            }));

            const ws = XLSX.utils.json_to_sheet(exportData);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Sales Report");

            XLSX.writeFile(wb, "Due_Report.xlsx");
            setIsExporting(false);
        }
    }, [reportData?.getDueExcelData?.data?.finalResult]);

    return (
        <>
            <div className="mt-[100px]">
                <div className="d-flex items-center gap-4">
                    <div className='w-[200px]'>
                        <label className="text-sm block mb-1">Service</label>
                        <select
                            value={formData.type} name='type' onChange={handleFormData}
                            className="!border-b w-full focus:outline-none"
                        >
                            <option value="">Select Service</option>
                            <option value="FILECHARGE">File Charge</option>
                            <option value="CONSULTANT">Consultation</option>
                            <option value="SERVICE">Services</option>
                            <option value="PACKAGE">Package</option>
                        </select>
                    </div>
                    <div className='w-[200px]'>
                        <label className="text-sm block mb-1">Date</label>
                        <input
                            type="date"
                            name="date"
                            value={formData.date}
                            onChange={handleFormData}
                            className="w-full outline-none !border-b"
                        />
                    </div>
                    <div className='w-[200px]'>
                        <label className="text-sm block mb-1">Start Date</label>
                        <input
                            type="date"
                            name="startDate"
                            value={formData.startDate}
                            onChange={handleFormData}
                            className="w-75 outline-none !border-b"
                        />
                    </div>
                    <div className='w-[200px]'>
                        <label className="text-sm block mb-1">End Date</label>
                        <input
                            type="date"
                            name="endDate"
                            value={formData.endDate}
                            onChange={handleFormData}
                            className="w-75 outline-none !border-b"
                        />
                    </div>
                    <div className="bg-white shadow-shadows py-[8px] px-[20px] rounded-full flex items-center gap-2 me-2 ms-auto">
                        <IoSearchOutline />
                        <input
                            type="text"
                            name="search"
                            value={formData.search}
                            onChange={handleFormData}
                            className="w-full outline-none"
                            placeholder="Search..."
                        />
                    </div>
                    <div className="me-2">
                        <Button
                            className="!bg-theme-dark fw-bold d-flex align-item-center border-0"
                            onClick={handleExport}  
                        >
                            <BsDownload className="mt-1 me-2" />
                            Download
                        </Button>
                    </div>
                </div>
                <div className='col-6 text-end ms-auto mt-4'>
                    <div className='flex justify-end gap-3 font-medium text-lg'>
                        <label className='text-center block text-gray-600 border-r pe-3'><span> Total Records :</span> <span className='ms-1 border-b border-gray-600'>{reportData?.dueAmountReport?.data?.totalRecord}</span></label>
                        {/* <label className='text-center block text-gray-600 border-r pe-3'><span> Net Amount :</span> <span className='ms-1 border-b border-gray-600'>{reportData?.dueAmountReport?.data?.totalAmount}</span></label> */}
                        {/* <label className='text-center block text-success border-r pe-3'><span>Received Amount : </span> <span className='ms-1 border-b border-success'>{reportData?.dueAmountReport?.data?.totalPaidAmount}</span></label> */}
                        <label className='text-center block text-danger'><span>Due Amount : </span> <span className='ms-1 border-b border-danger'>{reportData?.dueAmountReport?.data?.totalDueAmount}</span></label>
                    </div>
                </div>
            </div>

            <div className="mt-[50px] mb-4">
                <TableContainer>
                    <Table variant="striped" colorScheme="blackAlpha">
                        <Thead>
                            <Tr>
                                <Th>Date</Th>
                                <Th>Bill No</Th>
                                <Th>Name</Th>
                                <Th>Phone Number</Th>
                                <Th>Service Name</Th>
                                <Th>Rate</Th>
                                <Th>Bill Type</Th>
                                <Th>Total Amount </Th>
                                <Th>Paid amount</Th>
                                <Th>due amount</Th>
                                <Th>Branch</Th>
                                <Th>User</Th>
                                <Th>Action</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {
                                reportData?.dueAmountReport?.data?.finalResult?.length > 0 ? (
                                    reportData?.dueAmountReport?.data?.finalResult?.map((res) => {
                                        return (
                                            <Tr key={res._id}>
                                                <Td>{res.date ? moment(res.date).format('DD/MM/YYYY') : ''}</Td>
                                                <Td>{res.billNo}</Td>
                                                <Td className='capitalize'>{res.name}</Td>
                                                <Td>{res.phoneNumber}</Td>
                                                <Td>{res.packageName || res.serviceName || ' - '}</Td>
                                                <Td>{res.serviceRate || '-'}</Td>
                                                <Td>{res.billType}</Td>
                                                <Td>{res.totalAmount}</Td>
                                                <Td>{res.paidAmount}</Td>
                                                <Td>{res.dueAmount}</Td>
                                                <Td>{res.branch}</Td>
                                                <Td>{res.billGenerateBy}</Td>
                                                <Td><FiTarget className='text-primary text-xl cursor-pointer' title='view' onClick={() => { reportToggle(); handleReport(res.billNo); }} /></Td>
                                            </Tr>
                                        )
                                    })
                                ) : (
                                    <Tr>
                                        <Td colSpan={11} textAlign={'center'}>No any report</Td>
                                    </Tr>
                                )
                            }
                        </Tbody>
                    </Table>
                </TableContainer>
            </div>

            <ReactPaginate
                breakLabel="..."
                nextLabel="next >"
                onPageChange={ChangeMainPage}
                pageRangeDisplayed={5}
                pageCount={PageCount}
                previousLabel="< previous"
                renderOnZeroPageCount={null}
                className="pagination"
            />

            <Modal show={reportModal} size="lg" onHide={reportToggle} centered>
                <Modal.Body className='p-3'>
                    <Table>
                        <Thead>
                            <Tr>
                                <Th>Payment Date</Th>
                                <Th>Payment Time</Th>
                                <Th>Paid Amount</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {
                                reportData?.viewReport?.data?.history?.map((res) => {
                                    return (
                                        <>
                                            {
                                                res?.history?.map((res) => {
                                                    return (
                                                        <Tr key={res._id}>
                                                            <Td>{res.paymentDate ? moment(res.paymentDate).format('DD/MM/YYYY') : ''}</Td>
                                                            <Td>{res.paymentDate ? moment(res.paymentDate).format('hh:mm A') : ''}</Td>
                                                            <Td>{res.amount}</Td>
                                                        </Tr>
                                                    )
                                                })
                                            }
                                        </>
                                    )
                                })
                            }
                        </Tbody>
                    </Table>
                </Modal.Body>
                <Modal.Footer className='border-0'>
                    <Button
                        variant="secondary"
                        onClick={reportToggle}
                        className="px-4 bg-transparent border-[1px] text-black border-green-color"
                    >
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

